import useTranslation from "next-translate/useTranslation";
import { FaChevronDown, FaTrophy } from "react-icons/fa";
import { setLeaguePlay, useLobby } from "@/redux/lobby";

export default function LeaguePracticeSelect({ onFocus }) {
  const { leaguePlay } = useLobby();
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");

  return (
    <div className="relative min-w-0">
      {leaguePlay && (
        <FaTrophy
          aria-hidden="true"
          className="pointer-events-none absolute left-3 top-1/2 hidden -translate-y-1/2 text-primary min-[360px]:block"
        />
      )}
      <select
        aria-label={lobbyT("Mode")}
        value={leaguePlay ? "league" : "practice"}
        onFocus={onFocus}
        onChange={(event) => {
          const league = event.target.value === "league";
          if (league !== leaguePlay) setLeaguePlay(league);
        }}
        className={`h-full min-h-12 w-full cursor-pointer appearance-none rounded-md border-0 bg-white bg-none py-3 pl-3 pr-8 text-sm font-semibold text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary md:hover:bg-gray-50 ${
          leaguePlay ? "min-[360px]:pl-9" : ""
        }`}
      >
        <option value="league">{lobbyT("League")}</option>
        <option value="practice">{t("Practice")}</option>
      </select>
      <FaChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-600"
      />
    </div>
  );
}
